import React from "react";


const ImageCellRendererDeviceEvents = (props: any) => {
    //console.log(props);
    const onClickLink = () => {
        const image_window: any = window.open("", "_blank", 'toolbar=0,location=0,menubar=0');
        image_window.document.write(`
      <html>
        <head>
        </head>
        <body>
          <img src=${props.value} alt="Img" height="100%" width="100%">
        </body>
      </html>`);
        // console.log(props.data.lastImageUrl);

        // props.editAction("ShowImage", props.data);
    }
    return (
        <div className={"cellRenderHeader"}>
            <a><span onClick={onClickLink} className={"cellRender"}>{props && props.value}</span></a>
        </div>

    )
}

export default ImageCellRendererDeviceEvents;
